import React from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import Button from "../ui/Button";
import { BRAND } from "../../lib/config";
import { Blocks, Sparkles, Code2, ArrowUpRight } from "lucide-react";

function Spotlight({ icon: Icon, title, body, tag }) {
  return (
    <Card className="p-7 sm:p-8">
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-4">
          <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.03]">
            <Icon className="h-5 w-5 text-cyan-300" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div className="text-sm font-semibold text-white">{title}</div>

              {/* Tag: doesn’t break layout on small screens */}
              <div className="inline-flex w-fit rounded-full border border-white/10 bg-white/[0.02] px-3 py-1.5 text-xs font-semibold text-white/70">
                {tag}
              </div>
            </div>

            <p className="mt-2 text-sm leading-6 text-white/65">{body}</p>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default function SupportedGames() {
  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">
            SUPPORTED
          </div>

          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Host any game.
            <span className="block">
              Spotlight the best<span className="text-cyan-300">.</span>
            </span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            If it runs on Linux, it can run here — with fast deploys, predictable performance, and instant upgrades.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Spotlight
            icon={Blocks}
            title="Minecraft"
            tag="Featured"
            body="Vanilla or modded. Strong tick performance, fast NVMe, and clean scaling as your world and playerbase grow."
          />

          <Spotlight
            icon={Sparkles}
            title="Hytale"
            tag="Supported • Beta"
            body="Deploy Hytale from the panel via Pterodactyl eggs — configure, update, and scale like any other server."
          />

          <Spotlight
            icon={Code2}
            title="Code hosting"
            tag="Power users"
            body="Run bots, web apps, APIs, and tooling alongside your community. Great for teams that self-host services."
          />
        </div>

        <div className="mt-10 mx-auto max-w-4xl rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <div>
              <div className="text-sm font-semibold text-white">Need a specific game or stack?</div>
              <p className="mt-1 text-sm leading-6 text-white/65">
                Tell us what you’re running — we’ll help pick RAM and optimize it.
              </p>
            </div>

            <Button variant="secondary" href={BRAND.discordUrl} className="w-full sm:w-auto">
              Ask in Discord <ArrowUpRight className="h-4 w-4 opacity-70" />
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
